/**
 * Collection toolbar — grid/list view toggle. Purely a client-side CSS
 * switch (list mode collapses the grid to one column); no server round-trip.
 */
(function () {
  'use strict';

  function initToggle(toggle) {
    var grid = document.querySelector('[data-cv-grid]');
    if (!grid) return;

    toggle.querySelectorAll('button[data-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        toggle.querySelectorAll('button[data-view]').forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
        grid.classList.toggle('is-list', button.getAttribute('data-view') === 'list');
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-cv-view-toggle]').forEach(initToggle);
  }

  init();

  // Exposed so assets/collection-ajax.js can re-wire the toggle after
  // swapping in a freshly-fetched toolbar section.
  window.fixplusInitViewToggle = init;
})();
